import 'lazysizes';
import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    // Fix for firefox anim on scroll (stealed from Nat code on matchroom project)
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200)

  const video = document.getElementById('background-video');
  if(video)
    video.play();

  function inViewAnimAbout() {
    gsap.fromTo('.about-global .wrap-image .image' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })

    gsap.fromTo('.about-global .wrap-text-and-image .small-title' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })

    gsap.fromTo('.about-global .wrap-text-and-image .second-heading' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })

    gsap.fromTo('.about-global .wrap-text-and-image .wrap-inner-image-and-text .wrap-image' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })

    gsap.fromTo('.about-global .wrap-text-and-image .wrap-inner-image-and-text .wrap-text-and-link p' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })

    gsap.fromTo('.about-global .wrap-text-and-image .wrap-inner-image-and-text .wrap-text-and-link .link-to' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.about-global',
    })
  }
  inViewAnimAbout();

  /**************************************************************
    -> Breadcrumbs anim on scroll
    **************************************************************/
   function inViewAnimAboutVideo() {
    gsap.fromTo('.wrap-breadcrumbs' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.wrap-breadcrumbs',
    })
  }
  inViewAnimAboutVideo();

  const scrollTopBtn = document.querySelector('.scroll-top-button');

  const scrollFromTopFunc = () => {
    let y = window.scrollY;
    if (y > window.innerHeight / 1.5) {
      scrollTopBtn.classList.add('show');
    } else {
      scrollTopBtn.classList.remove('show');
    }
  };

  window.addEventListener('scroll', scrollFromTopFunc);

  function scrollToTop() {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 9, 'smooth');
    }
  }

  scrollTopBtn.addEventListener('click', scrollToTop)


  // Footer Logos Slider
  // eslint-disable-next-line no-unused-vars
  let footerLogoSwiper = new Swiper ('.swiper-container-footer-logo-list', {
    loop: true,
    // spaceBetween: 85,
    // slidesPerView: 5,
    roundLengths: true,
    grabCursor: true,
    speed: 500,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-footer-logos-next',
      prevEl: '.swiper-footer-logos-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
      // when window width is >= 760px
      760: {
        slidesPerView: 5,
        spaceBetween: 55,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 5,
        spaceBetween: 85,
      },
    },
  })

  /**************************************************************
    -> On this scroll amount show fixed nav 
  **************************************************************/
  const toggleMobileBurgerButton = () => {
    const burgerBtn = document.querySelector('.burger-button-js');
    const navOverlay = document.querySelector('.nav-overlay-mobile');
    const mobileHomeLink = document.querySelector('.mobile-home-link');
    const navLinks = document.querySelectorAll('.container-fixed-mobile-nav .nav-primary li')
    const navLinksReverse = Array.from(document.querySelectorAll('.container-fixed-mobile-nav .nav-primary li')).reverse()
    const navLinksSocial = document.querySelectorAll('.container-fixed-mobile-nav .wrap-nav-mobile-socials')

    let mobileNavClose = gsap.timeline({onComplete: function() {navOverlay.classList.remove('can-click')}});

    mobileNavClose
    .fromTo(navLinksSocial, 0.25, {opacity: 1}, {opacity: 0, ease: 'power4.inOut'})
    .fromTo(navLinksReverse, 0.25, {opacity: 1}, {opacity: 0, ease: 'power4.inOut', stagger:0.05})
    .fromTo(mobileHomeLink, 0.2, {opacity: 1}, {opacity: 0, ease: 'power4.inOut'})
    .fromTo(navOverlay, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.inOout'})

    
    mobileNavClose.pause()

    let mobileNavOpen = gsap.timeline({onComplete: function() {navOverlay.classList.add('can-click')}});

    mobileNavOpen
    .fromTo(navOverlay, 0.45, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})
    .fromTo(mobileHomeLink, 0.2, {opacity: 0, y: '5px'}, {opacity: 1, y: '0px', ease: 'power4.inOut'})
    .fromTo(navLinks, 0.25, {opacity: 0, y: '5px'}, {opacity: 1, y: '0px', ease: 'power4.inOut', stagger:0.07})
    .fromTo(navLinksSocial, 0.15, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})
    
    mobileNavOpen.pause()

    burgerBtn.addEventListener('click', () => {
      burgerBtn.classList.toggle('is-active');

      if (burgerBtn.classList.contains('is-active')) {
        mobileNavOpen.restart();
      } else {
        mobileNavClose.restart();
      }
    })
  }
  toggleMobileBurgerButton();

  /**************************************************************
    -> On this scroll amount show fixed nav 
  **************************************************************/
  const revealNavFixed = () => {
    const fixedNav = document.querySelector('.container-fixed-nav');
    const notFixedNav = document.querySelector('.container-not-fixed-nav');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 45) {
        fixedNav.classList.add('active')
        notFixedNav.classList.add('not-active')
      } else {
        fixedNav.classList.remove('active')
        notFixedNav.classList.remove('not-active')
      }
    })
  }
  revealNavFixed();

  /**************************************************************
    -> Highlight wishlist items that are already in the wishlist
  **************************************************************/
  const speakToOurTeam = () => {
    const triggerBtn = document.querySelector('.speak-to-team');
    const closeBtn = document.querySelector('.close-enquiry');
    const enquiryBg = document.querySelector('.enquiry-slide-in');
    const enquiryTitle = document.querySelector('.enquiry-title');
    const enquiryDetails = document.querySelector('.contact-details');
    const enquirySubtitle = document.querySelector('.subtitle');
    const enquiryForm = document.querySelector('.wrap-form');

    const enquirySlideANim = gsap.timeline({ paused: true })

      enquirySlideANim.fromTo(enquiryBg, { left: '-100%' }, { left: '0%', duration: 0.8, ease: 'power2.inOut' })
      enquirySlideANim.fromTo(enquiryTitle, { opacity: 0, y: '15px' }, { opacity: 1, y: '0%', duration: 0.3, ease: 'power2.out' }, '>-0.1')
      enquirySlideANim.fromTo(enquiryDetails, { opacity: 0, y: '15px' }, { opacity: 1, y: '0%', duration: 0.3, ease: 'power2.out' }, '>-0.1')
      enquirySlideANim.fromTo(enquirySubtitle, { opacity: 0, y: '15px' }, { opacity: 1, y: '0%', duration: 0.3, ease: 'power2.out' }, '>-0.15')
      enquirySlideANim.fromTo(enquiryForm, { opacity: 0, y: '15px' }, { opacity: 1, y: '0%', duration: 0.3, ease: 'power2.out' }, '>-0.13')
      
    triggerBtn.addEventListener('click', () => {
      enquirySlideANim.timeScale(1).play();
      enquirySlideANim.play();
    })

    closeBtn.addEventListener('click', () => {
      enquirySlideANim.timeScale(2).reverse();
    })
  }
  speakToOurTeam();


  // Get the wishlist count element
  const countWishlistIcon = Array.from(document.querySelectorAll('.banner .wishlist-count'));
  const countWishlistInner = document.querySelector('.wishlist-inner-count');
  /**************************************************************
    -> Highlight wishlist items that are already in the wishlist
  **************************************************************/
   const highlightWishlistItems = () => {
    const wishlistAddButtons = Array.from(document.querySelectorAll('.add-to-wishlist'));
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : [];

    // Update list counter number
    setTimeout( () => { 
      
      countWishlistIcon.forEach(element => {
        element.innerHTML = wishlist.length;
      })

      if (countWishlistInner) {
        countWishlistInner.innerHTML = wishlist.length
      }
    }, 300);

    if (wishlist) {
      wishlistAddButtons.forEach(element => {
        const thisID = element.dataset.id
        if (wishlist.includes(thisID)) {
          element.classList.add('active')
        }
      })
    }
  }
  highlightWishlistItems()

  /**************************************************************
  -> Wishlist button clicks
  **************************************************************/
  const addToWishlist = () => {
    const wishlistAddButtons = Array.from(document.querySelectorAll('.add-to-wishlist'))
    const tooltips = Array.from(document.querySelectorAll('.tooltip-added'))
    wishlistAddButtons.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const thisID = element.dataset.id
        // Get all the button of this id
        const getRelatedButtonsToID = Array.from(document.querySelectorAll(`.add-to-wishlist[data-id="${thisID}"]`));

        let wishlist = JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : []

        // Update list counter number
        setTimeout( () => { 
          countWishlistIcon.forEach(element => {
            element.innerHTML = wishlist.length;
          })
          if (countWishlistInner) {
            countWishlistInner.innerHTML = wishlist.length
          }
        }, 200);

        // Check if this item is already in the wish list
        if (element.classList.contains('active')) {
          // If it is in the wishlist, filter the value out
          wishlist = wishlist.filter(item => item !== thisID)
          element.classList.remove('active')
          // remove active on all the buttons of this id
          getRelatedButtonsToID.forEach(relatedButton => {
            relatedButton.classList.remove('active')
          })
        } else {
          // If this item isn't ative and the wishlist doesn't already
          // inlude this item, then add it and make it active
          if (!wishlist.includes(thisID)) {
            wishlist.push(thisID)
            element.classList.add('active')
            // remove active on all the buttons of this id
            getRelatedButtonsToID.forEach(relatedButton => {
              relatedButton.classList.add('active')
            })

            setTimeout(() => {
              tooltips.forEach(tooltip => {
                tooltip.classList.add('active');
              })
            }, 200);

            setTimeout(() => {
              tooltips.forEach(tooltip => {
                tooltip.classList.remove('active');
              })
            }, 1800);
          }
        }
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
      })
    })
  }
  addToWishlist()


  /**************************************************************
  -> Generate wishlist link in header
  **************************************************************/
  const clearWishlist = () => {
    const clearBtn = document.querySelector('.clear-wishlist');
    let wishlist = []

    if (clearBtn) {

      let wishlistInMemory = JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : [];
      console.log(wishlistInMemory)
      if(!wishlistInMemory.length) {
        // clearBtn.forEach(element => {
          clearBtn.classList.add('hide');
        // })
      }

      clearBtn.addEventListener('click', event => {
        localStorage.removeItem('wishlist');
        event.preventDefault()
        // Update list counter number
          setTimeout( () => { 
            countWishlistIcon.forEach(element => {
              element.innerHTML = wishlist.length;
            })
            countWishlistInner.innerHTML = wishlist.length
          }, 300);
  
          window.location.href = '/your-wishlist'
  
      })
    }
  }
  clearWishlist();


  /**************************************************************
  -> Generate wishlist link in header
  **************************************************************/
   const headerWishlistLink = () => {
    const links = Array.from(document.querySelectorAll('.wrap-wishlist-icon'))

    links.forEach(link => {
      link.addEventListener('click', event => {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : []
        const paramIds = wishlist.toString()
        const generatedLink = `/your-wishlist?ids=${paramIds}`
        event.preventDefault()
        window.location.href = generatedLink
      });
    })
  }
  headerWishlistLink()



  /**************************************************************
  -> Handle add and remove items inside the wishlist
  **************************************************************/
  const handleItemsInsideWishlist = () => {
    const wishlistAddButtons = Array.from(document.querySelectorAll('.add-to-wishlist-inside-wishlist'))
    wishlistAddButtons.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const thisID = element.dataset.id

        let wishlist = JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : []

        // Update list counter number
        setTimeout( () => { 
          countWishlistIcon.innerHTML = wishlist.length
          countWishlistInner.innerHTML = wishlist.length
        }, 300);

        // Check if this item is already in the wish list
        if (element.classList.contains('active')) {
          // If it is in the wishlist, filter the value out
          wishlist = wishlist.filter(item => item !== thisID)
          element.classList.remove('active')
        } else {
          // If this item isn't ative and the wishlist doesn't already
          // inlude this item, then add it and make it active
          if (!wishlist.includes(thisID)) {
            wishlist.push(thisID)
            element.classList.add('active')
          }
        }
        localStorage.setItem('wishlist', JSON.stringify(wishlist));

        const paramIds = wishlist.toString()
        const generatedLink = `/your-wishlist?ids=${paramIds}`
        event.preventDefault()
        window.location.href = generatedLink
      })
    })
  }
  handleItemsInsideWishlist();



   /**************************************************************
  -> Handle toggle the newsletter pop up
  **************************************************************/
  const body = document.querySelector('body');
  const btnOpenNewsletter = document.querySelector('.signup-band');
  const btnCloseNewsletter = document.querySelector('.close-pop-up-newsletter');
  const popUp = document.querySelector('.wrap-pop-up');
  const popUpDisableBg = document.querySelector('.background-overlay');

  let popUpAnimClose = gsap.timeline();

  popUpAnimClose
  .fromTo(popUp, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.out'})
  .fromTo(popUpDisableBg, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.inOut'},'-=0.15')
  
  popUpAnimClose.pause()
  
  let popUpAnim = gsap.timeline();

  popUpAnim
  .fromTo(popUpDisableBg, 0.35, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})
  .fromTo(popUp, 0.25, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})

  popUpAnim.pause()
  

  // // Handle click opening nav and closing
  if (btnOpenNewsletter) {
    btnOpenNewsletter.addEventListener('click', function() {
      body.classList.add('overflow-hidden');
      popUp.classList.add('can-click');
      popUpDisableBg.classList.add('can-click');
      popUpAnim.restart();
    })
  }

  if (btnCloseNewsletter) {
    btnCloseNewsletter.addEventListener('click', function() {
      body.classList.remove('overflow-hidden');
      popUp.classList.remove('can-click');
      popUpDisableBg.classList.remove('can-click');
      popUpAnimClose.restart();
    })
  }

  // // Handle click closing nav on the black transparent part of the nav
  if (popUpDisableBg) {
    popUpDisableBg.addEventListener('click', function() {
      body.classList.remove('overflow-hidden');
      popUp.classList.remove('can-click');
      popUpDisableBg.classList.remove('can-click');
      popUpAnimClose.restart();
    })
  }


  /**************************************************************
  -> Handle Custom Popup
  **************************************************************/
  const customPopup = document.querySelector('.custom-popup');
  
  if (customPopup) {
    const showEveryTime = customPopup.getAttribute('data-show-every-time') === 'true';
    const popupId = customPopup.getAttribute('data-popup-id');
    const enable = customPopup.getAttribute('data-enable') === 'true';
    const sessionStorageKey = 'custom_popup_shown';
    
    const customPopupBackdrop = customPopup.querySelector('.custom-popup__backdrop');
    const customPopupContent = customPopup.querySelector('.custom-popup__content');
    const customPopupClose = customPopup.querySelector('.custom-popup__close');
    
    // Animation setup
    let customPopupAnimClose = gsap.timeline();
    
    customPopupAnimClose
      .fromTo(customPopupContent, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.out'})
      .fromTo(customPopupBackdrop, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.inOut'}, '-=0.15')
      .set(customPopup, {display: 'none'});
    
    customPopupAnimClose.pause();
    
    let customPopupAnim = gsap.timeline();
    
    customPopupAnim
      .set(customPopup, {display: 'block'})
      .fromTo(customPopupBackdrop, 0.35, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})
      .fromTo(customPopupContent, 0.25, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'}, '-=0.15');
    
    customPopupAnim.pause();
    
    // Function to open popup
    const openPopup = function() {
      body.classList.add('overflow-hidden');
      customPopup.classList.add('can-click');
      customPopupBackdrop.classList.add('can-click');
      customPopupAnim.restart();
    };
    
    // Function to close popup
    const closePopup = function() {
      body.classList.remove('overflow-hidden');
      customPopup.classList.remove('can-click');
      customPopupBackdrop.classList.remove('can-click');
      customPopupAnimClose.restart();
      
      // Set sessionStorage if show_every_time is false
      if (!showEveryTime) {
        sessionStorage.setItem(sessionStorageKey, 'true');
      }
    };
    
    // Check if popup should be shown on page load
    // Don't show if form was submitted (sessionStorage is set), even if showEveryTime is true
    const hashMatch = popupId && window.location.hash === '#' + popupId;
    const shouldShowPopup = enable && !sessionStorage.getItem(sessionStorageKey) && !hashMatch;
    
    if (shouldShowPopup) {
      // Show popup on page load
      setTimeout(() => {
        openPopup();
      }, 500);
    } else if (!hashMatch) {
      // Hide popup if it shouldn't be shown (unless hash matches)
      customPopup.style.display = 'none';
    }
    
    // Check for hash on page load and hash changes
    // This works even if enable is false
    const checkHash = function() {
      if (popupId && window.location.hash === '#' + popupId) {
        openPopup();
      }
    };
    
    // Check hash on page load (works even if enable is false)
    if (hashMatch) {
      setTimeout(() => {
        openPopup();
      }, 100);
    }
    
    // Listen for hash changes
    window.addEventListener('hashchange', checkHash);
    
    // Close button handler
    if (customPopupClose) {
      customPopupClose.addEventListener('click', function() {
        closePopup();
        
        // Remove hash from URL if it matches popup_id
        if (popupId && window.location.hash === '#' + popupId) {
          history.pushState('', document.title, window.location.pathname + window.location.search);
        }
      });
    }
    
    // Backdrop click handler
    if (customPopupBackdrop) {
      customPopupBackdrop.addEventListener('click', function() {
        closePopup();
        
        // Remove hash from URL if it matches popup_id
        if (popupId && window.location.hash === '#' + popupId) {
          history.pushState('', document.title, window.location.pathname + window.location.search);
        }
      });
    }

    // Gravity Forms success event listener
    // Listen for form confirmation loaded event
    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
      // Find the confirmation wrapper that appears after form submission
      const confirmationWrapper = jQuery('#gform_confirmation_wrapper_' + formId);
      
      // Check if this confirmation is within our custom popup
      if (confirmationWrapper.length && confirmationWrapper.closest('.custom-popup').length) {
        // Set sessionStorage to prevent popup from showing again on page refresh
        sessionStorage.setItem(sessionStorageKey, 'true');
      }
    });
  }


  /**************************************************************
  -> Handle toggle the Search overlay
  **************************************************************/
//  const body = document.querySelector('body');
 const btnOpenSearch = Array.from(document.querySelectorAll('.search-icon-open-js'));
 const btnCloseSearch = document.querySelector('.close-search-bar-js');
 const popUpSearch = document.querySelector('.search-bar-overlay-js');
 const searchForm = popUpSearch.querySelector('.search-bar')

 let searchAnimClose = gsap.timeline();

 searchAnimClose
 .fromTo(popUpSearch, 0.35, {opacity: 1}, {opacity: 0, ease: 'power4.out'})
 
 searchAnimClose.pause()
 
 let searchAnim = gsap.timeline();

 searchAnim
 .fromTo(popUpSearch, 0.25, {opacity: 0}, {opacity: 1, ease: 'power4.inOut'})

 searchAnim.pause()
 

 // // Handle click opening nav and closing
 if (btnOpenSearch) {

  btnOpenSearch.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault()
      body.classList.add('overflow-hidden');
      popUpSearch.classList.add('can-click');
      searchForm.classList.add('can-click');
      searchAnim.restart();
    })
  })
 }

 if (btnCloseSearch) {
  btnCloseSearch.addEventListener('click', function() {
     body.classList.remove('overflow-hidden');
     popUpSearch.classList.remove('can-click');
     searchForm.classList.remove('can-click');
     searchAnimClose.restart();
   })
 }

 // Fix problem with mobile keyboard
 if(screen.width <= 767) {
   $('.filter-search input[type="search"]').blur(function() {
      var self = this
      setTimeout(function(){
            const topPosition = $(self).height() + $(self).offset().top + 16;
            $('.searchwp-live-search-results').css('top', topPosition + 'px');
      }, 100)
    })
 }

 // Remove background video on mobile
 if(screen.width <= 767) {
  $('.wrap-fullscreen-video.desktop-only').remove();
 }

 // Disable pressing enter tab to search bar
 const searchInput = popUpSearch.querySelector('input')

 searchInput.addEventListener('keypress', (event) => {
  if (event.keyCode === 13) {
    event.preventDefault();
  }
 })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js